  export function debounce(fun, wait, immediate) {
    let timeout;
    return function (...args) {
      let context = this;
      if (timeout) clearTimeout(timeout)
      if (immediate) {
        let callNow = !timeout;
        timeout = setTimeout(function () {
          timeout = null;
        }, wait)
        if (callNow) fun.apply(context, args)
      } else {
        timeout = setTimeout(function () {
          fun.apply(context, args)
        }, wait)
      }
    }
  }

  /* 下载资源方法 */
  export function downloadByJs(url, name) {
    if (url && name) {
      let DOM_A = document.createElement('a');
      const DOM_BODY = document.querySelector('body')
      // DOM_A.href = url;
      // DOM_A.download = name;
      DOM_A.setAttribute("href", url);
      DOM_A.setAttribute("download", name)
      DOM_BODY.appendChild(DOM_A);
      DOM_A.click();
      setTimeout(() => {
        DOM_BODY.removeChild(DOM_A)
      }, 40)
    } else {
      console.error('下载信息异常/n', 'url:', url, 'name:', name)
    }
  }

export function getType( val) {
  if(!val) return
  return Object.prototype.toString.call(val).slice(8,-1)
}

export function isTimeBefore(inputStamp, standStamp, momentStr = 'day') {
  const moment = require('moment');
  const inputs = moment(inputStamp).format('yyyy-MM-DD');
  const stands = moment(standStamp).format('yyyy-MM-DD');
  return moment(inputs).isBefore(stands, momentStr)
}

// 输出 当天时间戳（2022-04-09 00:00:00 =》 1649433600000）
export function getNowTime() {
  const moment = require('moment');
  const time = moment().format('yyyy-MM-DD');
  const timeStamp = moment(time).valueOf();
  return timeStamp;
}